import LightTheme from 'common/config/theme/app/light'
import DarkTheme from 'common/config/theme/app/dark'
import GrayTheme from 'common/config/theme/app/gray'

export const THEMES = {
	light: LightTheme,
	dark: DarkTheme,
	gray: GrayTheme
}
